import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { FunctionField, Labeled, ReferenceField, TextField } from "react-admin";
import { WeekDaysChoices } from "utils/choices";

const InfoBlock = ({ disciplineId, currentSchedule, specialityId }) => {
  return (
    <Grid
      container
      sx={{ gap: 3, mb: 2 }}
    >
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="Специалност">
          <ReferenceField
            record={{ specialityId }}
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>

      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="Дисциплина">
          <ReferenceField
            record={{ disciplineId }}
            source="disciplineId"
            reference={administrationRequests.getDisciplinesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="Тип">
          <ReferenceField
            record={currentSchedule}
            source="classTypeId"
            reference={administrationRequests.getRoomClassTypesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="Ден">
          <FunctionField
            record={currentSchedule}
            render={rec => WeekDaysChoices.find(d => d.id === rec.weekDay)?.name}
          />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="Час">
          <FunctionField
            record={currentSchedule}
            render={rec => `${rec.startTime.slice(0, 5)} - ${rec.endTime.slice(0, 5)}`}
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default InfoBlock;
